import { Box, Button, ButtonProps } from '@mui/material'
import React from 'react'
import { useInstallationAccessRightsContext } from 'src/Libs/installation-rights-management/provider/InstallationAccessRightsContext'
import { LinkIcon, TransferArrowsIcon } from '../icons'
type PairingButtonProps = Omit<ButtonProps, 'startIcon' | 'color' | 'variant'> & {
  icon: 'link' | 'transfer'
  children: string
}

export const PairingButton: React.FC<PairingButtonProps> = props => {
  const { hasInstallationWritingRights: canEdit } = useInstallationAccessRightsContext()

  const { children, icon, disabled, ...buttonProps } = props

  return (
    <Button
      {...buttonProps}
      variant="outlined"
      sx={{ py: 1, borderColor: 'primary.main', overflow: 'hidden' }}
      startIcon={icon === 'transfer' ? <TransferArrowsIcon /> : <LinkIcon />}
      disabled={disabled || !canEdit}
    >
      <Box sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0 }}>{children}</Box>
    </Button>
  )
}
